export default {
    computed: {
        $zoom() {
            return {
                STEP: 0.25,
                in: () => {
                    if (+this.getZoom >= 3) return;
                    const zoom = +(+this.getZoom).toFixed(2);
                    if (this.$zoom.checkIsNotStandart()) {
                        // переходим на следующий шаг
                        this.$store.commit('SET_NEW_ZOOM', (zoom + this.$zoom.STEP).toFixed(2));
                    } else {
                        // вычисляем сколько надо добавить нестандартному зуму до следующего стандартного шага
                        const term = +(this.$zoom.STEP - (zoom % this.$zoom.STEP)).toFixed(2);
                        this.$store.commit('SET_NEW_ZOOM', (zoom + term).toFixed(2));
                    }
                },
                out: () => {
                    if (+this.getZoom <= this.$zoom.STEP) return;
                    const zoom = +(+this.getZoom).toFixed(2);
                    if (this.$zoom.checkIsNotStandart()) {
                        // переходим на следующий шаг
                        this.$store.commit('SET_NEW_ZOOM', (zoom - this.$zoom.STEP).toFixed(2));
                    } else {
                        // вычисляем сколько надо отнять от нестандартного зума до следующего стандартного шага
                        const term = +(zoom % this.$zoom.STEP).toFixed(2);
                        this.$store.commit('SET_NEW_ZOOM', zoom - term);
                    }
                },
                checkIsNotStandart: () => !(Math.round(this.getZoom * 100) % Math.round(this.$zoom.STEP * 100))
            };
        }
    }
};
